import { Component } from "react";
import { withRouter } from "react-router-dom";

import type { ReactNode } from "react";

type Props = {
  location: unknown;
  children?: ReactNode;
};
class ScrollToTop extends Component<Props> {
  // @ts-expect-error TS7006
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default withRouter(ScrollToTop as any);
